(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

$(function () {
  var swiperWorks = new Swiper('.swiper-works', {
    slidesPerView: 2,
    spaceBetween: 10,
    loop: true,
    freeMode: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
  $('.opneing_modal_active').css('opacity', '0');
  Pace.on('done', function () {
    $.when().done(function () {
      $.when($(".__map").addClass("map-anime"), $(".__base").addClass("base-anime"), $('.l-main-ls').fadeIn()).done(function () {
        setTimeout(function () {
          $('opening_modal').css('opacity', '1'), $('.opneing_modal_active').css('opacity', '1'), $(function () {
            // swiper init
            var slideSwiper = new Swiper('.swiper-container_open', {
              allowTouchMove: false,
              navigation: {
                nextEl: '.swiper-next'
              },
              pagination: {
                el: '.opening-pagination',
                type: 'bullets',
                clickable: false
              },
              spaceBetween: 100
            });
          }), $(".__map").removeClass("map-anime"), $(".__base").removeClass("base-anime"), $(function () {
            var mapWidth = $(".__map").width();
            var windWidth = $(".__base").width();
            var scrollwidth = (windWidth - mapWidth) / 2; //$('.__map').scrollLeft(scrollwidth);

            $('.__map').animate({
              scrollLeft: scrollwidth
            }, 1000, 'swing');
          });
        }, 3800);
      });
    });
  }); //モーダルウィンドウ

  $('.js-modal-open').each(function () {
    $(this).on('click', function () {
      var target = $(this).data('target');
      var modal = document.getElementById(target);
      $(modal).fadeIn();
      var swiperWorks = new Swiper('.swiper-works', {
        slidesPerView: 2,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
      return false;
    });
  });
  $('.js-modal-close').on('click', function () {
    $('.js-modal').fadeOut();
    return false;
  });
  $('.js-modal-close-btn').on('click', function () {
    $('.js-modal').fadeOut();
    return false;
  });
}); //人物をクリックするとモーダル非表示に

$('.__person').on('click', function () {
  $('.js-modal').fadeOut();
  return false;
});
$(function () {
  $('.js-modal-open-03').each(function () {
    $(this).on('click', function () {
      var target = $(this).data('target');
      var modal = document.getElementById(target);
      $('.js-modal-03').fadeOut();
      $(modal).fadeIn();
      return false;
    });
  });
  $('.js-modal-close-03').on('click', function () {
    $('.js-modal-03').fadeOut();
    $('.__pin').removeClass('__pin--red');
    return false;
  });
}); //ピンをクリックしたときに赤くなる

$('.__pin').each(function () {
  $(this).on('click', function () {
    //var target = $(this).data('target');
    //var modal = document.getElementById(target);
    $('.__pin').removeClass('__pin--red');
    $(this).addClass('__pin--red'); //$(modal).fadeIn();

    return false;
  });
}); //ピンをクリックしたときに赤くなる

$('.product-img').each(function () {
  $(this).on('click', function () {
    var target = $(this).data('target');
    var pin = document.getElementById(target);
    $('.__pin').removeClass('__pin--red');
    $(pin).addClass('__pin--red');
  });
}); // 読み込み時出現するモーダルの制御

var openingModalFunc = function openingModalFunc() {
  var modal = document.getElementById('opening_modal');
  var buttonElm = document.getElementById('opneing_next_button');
  var slides = document.getElementsByClassName('swiper-slide-opening');
  var close = document.getElementById("opening-modal-close"); // モーダル出現

  modal.classList.add('opneing_modal_active');

  close.onclick = function () {
    modal.classList.remove('opneing_modal_active');
    setTimeout(function () {
      return modal.remove();
    }, 500);
  }; // swiper init


  var slideSwiper = new Swiper('.swiper-container_open', {
    allowTouchMove: false,
    navigation: {
      nextEl: '.swiper-next'
    },
    pagination: {
      el: '.opening-pagination',
      type: 'bullets',
      clickable: false
    },
    spaceBetween: 100
  }); // 最後の要素のときに閉じるにして、クリックすると消える処理

  buttonElm.addEventListener('click', function () {
    if (slideSwiper.activeIndex === slides.length - 1) {
      buttonElm.innerHTML = 'Lighting SceneへGO';
      buttonElm.addEventListener('click', function () {
        modal.classList.remove('opneing_modal_active');
        setTimeout(function () {
          return modal.remove();
        }, 500);
      });
    }
  });
}; // アクティブなボタンと非アクティブなボタンの表示を切り替える関数


var buttonToggleFunc = function buttonToggleFunc(highlightButton, index) {
  var activeIndex = index + 1;
  Object.values(highlightButton).forEach(function (button, currentIndex) {
    var image = button.getElementsByTagName('img');

    if (index === currentIndex && !image[0].src.includes('_active')) {
      image[0].src = image[0].src.replace("highlight_button".concat(activeIndex), "highlight_button".concat(activeIndex, "_active"));
    }

    if (index !== currentIndex && image[0].src.includes('_active')) {
      image[0].src = image[0].src.replace("highlight_button".concat(currentIndex + 1, "_active"), "highlight_button".concat(currentIndex + 1));
    }
  });
}; // hightlightのitem切り替えを行うイベントの登録


var changeHighlightItem = function changeHighlightItem() {
  // button
  var highlightButton = document.getElementsByClassName('highlight_button'); // highlight

  var highlightItem = document.getElementsByClassName('highlight_item');
  Object.values(highlightButton).forEach(function (button, index) {
    // すべてがクリックされた場合
    if (index === 0) {
      button.addEventListener('click', function () {
        Object.values(highlightItem).forEach(function (item) {
          item.style.display = 'block';
        });
        buttonToggleFunc(highlightButton, index);
      });
    } // すべて以外がクリックされた場合


    if (index !== 0) {
      button.addEventListener('click', function () {
        Object.values(highlightItem).forEach(function (item) {
          if (item.id === "item_highlight_".concat(index)) {
            item.style.display = 'block';
            return;
          }

          item.style.display = 'none';
        });
        buttonToggleFunc(highlightButton, index);
      });
    }
  });
}; // アクティブなボタンと非アクティブなボタンの表示を切り替える関数 SP


var buttonToggleFuncSP = function buttonToggleFuncSP(highlightButton, index) {
  var activeIndex = index + 1;
  Object.values(highlightButton).forEach(function (button, currentIndex) {
    if (index === currentIndex) {
      button.classList.add('btn_active');
    }

    if (index !== currentIndex) {
      button.classList.remove('btn_active');
    }
  });
}; // hightlightのitem切り替えを行うイベントの登録SP


var changeHighlightItemSP = function changeHighlightItemSP() {
  // button
  var highlightButton = document.getElementsByClassName('highlight_button_sp'); // highlight

  var highlightItem = document.getElementsByClassName('highlight_item');
  Object.values(highlightButton).forEach(function (button, index) {
    // すべてがクリックされた場合
    if (index === 0) {
      button.addEventListener('click', function () {
        Object.values(highlightItem).forEach(function (item) {
          item.style.display = 'block';
        });
        buttonToggleFuncSP(highlightButton, index);
      });
    } // すべて以外がクリックされた場合


    if (index !== 0) {
      button.addEventListener('click', function () {
        Object.values(highlightItem).forEach(function (item) {
          if (item.id === "item_highlight_".concat(index)) {
            item.style.display = 'block';
            return;
          }

          item.style.display = 'none';
        });
        buttonToggleFuncSP(highlightButton, index);
      });
    }
  });
};

$(".highlight_button_sp").on("click", function () {
  //フェードインする
  $('#__darkmask').addClass('active').delay(5000).queue(function () {
    //コールバックで3秒後にフェードアウト	
    $(this).removeClass("active").dequeue();
  });
  $('#highlight_sp').addClass('active').delay(5000).queue(function () {
    //コールバックで3秒後にフェードアウト	
    $(this).removeClass("active").dequeue();
  });
  $('#hl_news').addClass('active').delay(5000).queue(function () {
    //コールバックで3秒後にフェードアウト	
    $(this).removeClass("active").dequeue();
  });
  $('#quiz-drone').addClass('active').delay(5000).queue(function () {
    //コールバックで3秒後にフェードアウト	
    $(this).removeClass("active").dequeue();
  });
  $(".fukidashi").each(function () {
    $(this).addClass('active').delay(5000).queue(function () {
      //コールバックで3秒後にフェードアウト	
      $(this).removeClass("active").dequeue();
    });
  });
  $(".__person").each(function () {
    $(this).addClass('active').delay(5000).queue(function () {
      //コールバックで3秒後にフェードアウト	
      $(this).removeClass("active").dequeue();
    });
  });
});
$(".highlight_button").on("click", function () {
  //フェードインする
  $('#__darkmask').addClass('active').delay(5000).queue(function () {
    //コールバックで3秒後にフェードアウト	
    $(this).removeClass("active").dequeue();
  });
  $('#__hl_box').addClass('active').delay(5000).queue(function () {
    //コールバックで3秒後にフェードアウト	
    $(this).removeClass("active").dequeue();
  });
  $('#highlight_sp').addClass('active').delay(5000).queue(function () {
    //コールバックで3秒後にフェードアウト	
    $(this).removeClass("active").dequeue();
  });
  $('#hl_news').addClass('active').delay(5000).queue(function () {
    //コールバックで3秒後にフェードアウト	
    $(this).removeClass("active").dequeue();
  });
  $('#quiz-drone').addClass('active').delay(5000).queue(function () {
    //コールバックで3秒後にフェードアウト	
    $(this).removeClass("active").dequeue();
  });
  $(".fukidashi").each(function () {
    $(this).addClass('active').delay(5000).queue(function () {
      //コールバックで3秒後にフェードアウト	
      $(this).removeClass("active").dequeue();
    });
  });
  $(".__person").each(function () {
    $(this).addClass('active').delay(5000).queue(function () {
      //コールバックで3秒後にフェードアウト	
      $(this).removeClass("active").dequeue();
    });
  });
});
$(".__warning-sp").on("click", function () {
  //フェードインする
  $('#__darkmask').addClass('active-w');
  $('#__warning-sp').addClass('active-w');
  $('#highlight_sp').addClass('active-w');
  $('#hl_news').addClass('active');
  $('#quiz-drone').addClass('active-w');
  $(".__warning-logo").each(function () {
    $(this).addClass('active-w');
  });
  $(".highlight_item").each(function () {
    $(this).addClass('active-w');
    $(this).removeClass("blinking");
  });
});
var logonum = 0;
$(".__warning-logo").on("click", function () {
  logonum = logonum + 1;
  $(this).addClass('__warning-del');
  console.log(logonum);

  if (logonum == 5) {
    console.log("finish"); //フェードインする

    $('#__darkmask').addClass('active').delay(5000).queue(function () {
      //コールバックで3秒後にフェードアウト	
      $(this).removeClass("active").dequeue();
    }); // $('#__hl_box').addClass('active').delay(5000).queue(function () {
    //   $(this).removeClass("active").dequeue();
    // });

    $('#quiz-drone').addClass('active').delay(5000).queue(function () {
      //コールバックで3秒後にフェードアウト	
      $(this).removeClass("active").dequeue();
    });
    $(".fukidashi").each(function () {
      $(this).addClass('active').delay(5000).queue(function () {
        //コールバックで3秒後にフェードアウト	
        $(this).removeClass("active").dequeue();
      });
    });
    $(".__person").each(function () {
      $(this).addClass('active').delay(5000).queue(function () {
        //コールバックで3秒後にフェードアウト	
        $(this).removeClass("active").dequeue();
      });
    });
    $(".highlight_item").each(function () {
      $(this).removeClass('active-w');
      $(this).addClass("blinking");
    });
    $('#hl_news').delay(5000).queue(function () {
      $(this).removeClass("active").dequeue();
    });
    $('#highlight_sp').delay(5000).queue(function () {
      $(this).removeClass("active-w").dequeue();
    });
    var target = "modal-warning-logo-finish";
    var modal = document.getElementById(target);
    $(modal).delay(5000).fadeIn();
  } else {
    var remaininglogo = 5 - logonum;
    console.log(remaininglogo);
    var target = $(this).data('target');
    var modal = document.getElementById(target);
    var contentBlock = document.getElementById('__logo-message');
    contentBlock.innerHTML = 'あと' + remaininglogo + '個';
    $(modal).fadeIn();
    return false;
  }
}); // 定義した関数をDOM解析終わったら実行

window.addEventListener('DOMContentLoaded', function () {
  openingModalFunc();
  changeHighlightItem();
  changeHighlightItemSP();
});

},{}]},{},[1]);
